// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QTvNzaDNitmKcBCb3JZ3{position:relative}`, "",{"version":3,"sources":["webpack://./src/components/NLUData/NLUDataExample/EntitySection/MessageSection/message-section.module.scss"],"names":[],"mappings":"AAAA,sBACI,iBAAA","sourcesContent":[".messageSection {\n    position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageSection": `QTvNzaDNitmKcBCb3JZ3`
};
export default ___CSS_LOADER_EXPORT___;
